import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

import { fonts, icons } from '@cobliteam/base-components/src/styles';

export const badge = css`
  display: flex;
  align-items: center;
  border-radius: 3px;
  padding: 6px 10px;
  font-size: ${fonts.size.smallest};
  font-weight: ${fonts.weight.medium};

  & svg {
    margin-right: 10px;
    width: ${icons.size.smallest};
    height: ${icons.size.smallest};
  }
`;

export const badgeDefault = css`
  font-weight: ${fonts.weight.regular};
  background-color: ${colors.gray.a2};
  color: ${colors.gray[10]};
`;

export const badgeClient = css`
  background-color: ${colors.success.a2};
  color: ${colors.success[9]};
`;

export const badgeBase = css`
  background-color: ${colors.primary.a2};
  color: ${colors.primary[9]};
`;

export const badgeOther = css`
  background-color: ${colors.warning.a2};
  color: ${colors.warning[9]};
`;

export const filteredHighlight = css`
  width: 370px;
  box-sizing: border-box;
  display: inline-flex;
  padding: 10px;
  border-radius: 5px;
  margin-top: 15px;
  justify-content: center;
  background: ${colors.gray[4]};

  > span {
    color: ${colors.black.DEFAULT};
  }
`;
